import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneMask',
})
export class PhoneMaskPipe implements PipeTransform {
  private readonly PHONE_REGEX = /(\d{3})(\d{3})(\d{4})/;
  private readonly PHONE_FORMAT = '($1) $2-$3';

  transform(value?: string | null): string {
    if (!value) return '-';
    return value.replace(this.PHONE_REGEX, this.PHONE_FORMAT);
  }
}
